import BaseApiService from "./base-services/baseApi.service";

class SessionApiService extends BaseApiService {
    constructor() {
        super();
    }

    /**
     * Updates session data based on the type (ADDRESS, CENTRE, CART, HOOKCITY).
     *
     * @param {string} sessionUpdateType - The type of session update. Can be one of: 'ADDRESS', 'CENTRE', 'CART', 'HOOKCITY'.
     * @param {Object} updateData - Data to be updated in the session. This varies based on sessionUpdateType:
     *
     *   If sessionUpdateType === 'ADDRESS':
     *     updateData = {
     *       address: {
     *         pincode: string,        // Required. Pincode of the address.
     *         addressGuid: string     // Required. GUID of the address.
     *       }
     *     }
     *
     *   If sessionUpdateType === 'CENTRE':
     *     updateData = {
     *       centreDetails: {
     *         cityId: string,         // Required. City ID for the centre.
     *         centreId: string,       // Required. Centre ID.
     *         stateCode: string       // Required. State code where the centre is located.
     *       }
     *     }
     *
     *   If sessionUpdateType === 'CART':
     *     updateData = {
     *       cartDetails: {
     *         centreCartId: string,   // Optional. Cart ID for centre bookings.
     *         homeCartId: string      // Optional. Cart ID for home bookings.
     *       }
     *     }
     *
     *   If sessionUpdateType === 'HOOKCITY':
     *     updateData = {
     *       hookCityId: string        // Required. ID of the hooked city.
     *     }
     *
     * @returns {Promise<Object>} - Returns a promise that resolves with the API response.
     */
    updateSession = async (sessionUpdateType, updateData) => {
        // Create the request payload based on the sessionUpdateType
        const payload = {
            sessionUpdateType,
        };

        // Add the relevant data to the payload based on the sessionUpdateType
        if (sessionUpdateType === "ADDRESS") {
            payload.address = updateData.address; // expects pincode and addressGuid
        } else if (sessionUpdateType === "CENTRE") {
            payload.centreDetails = updateData.centreDetails; // expects cityId, centreId, and stateCode
        } else if (sessionUpdateType === "CART") {
            payload.cartDetails = updateData.cartDetails; // expects centreCartId and/or homeCartId
        } else if (sessionUpdateType === "HOOKCITY") {
            payload.hookCityId = updateData.hookCityId; // expects hookCityId
        }

        const url = "/auth/update-session";
        const response = await this.axiosInstance.post(url, payload);

        // Return the response data
        return response.data;
    };
}

const sessionApiService = new SessionApiService();
export { sessionApiService };
